// 常规巡检类型
import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import {
  PlusOutlined,
  SearchOutlined,
  MenuOutlined,
  DeleteOutlined,
  GlobalOutlined,
  EditOutlined,
  CaretRightOutlined,
  NodeIndexOutlined,
  ExclamationCircleFilled
} from '@ant-design/icons';
import { Card, Button, Dropdown, Input, Space, Table, message as AntMessage, App, Pagination, Drawer, Form, InputNumber, theme, Select, Switch } from 'antd';

import dayjs from 'dayjs';
import { getFlyRouteApi, setRoutesApi, delRoutesApi, setStatusApi, derivedInfoApi, temporaryExecutionApi } from '@/server/new_pipeline_inspection.js'
import { getDockElectricityApi } from '@/server/home.js'

import { basicPath } from '@/router/config';//引入路由基础路径
const { TextArea } = Input;

function NewPipelineInspection() {
  const {
    token: { colorTextPlaceholder, },
  } = theme.useToken(); //获取主题颜色
  const [messageApi, contextHolder] = AntMessage.useMessage();
  const { message, modal } = App.useApp();
  const { confirm } = modal;

  //type 1 常规巡检 2 高危巡检 3 采集读数
  const location = useLocation();//接受传值数据
  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false);
  //表格筛选条件
  const [search, setSearch] = useState({
    access_token: token,
    type: 10,
    fly_name: '',//航线名称
    description: '',//覆盖对象
    dock_id: '',//机场id
    page: 1,
    perpage: 10,
  });
  const [cur, setCur] = useState(1);//当前页
  const [page, setPage] = useState(10);//每页多少条
  const [total, setTotal] = useState(0);//总条数
  const [AirportPermissionsArr, setAirportPermissionsArr] = useState([])//权限
  const searchInput = useRef(null);//搜索框数据
  const [tableData, setTableData] = useState([]);//表格数据
  const [choose_id, setChooseId] = useState('');//当前选择的管线id

  const [modal_show, setDrawerShow] = useState(false);//是否显示弹窗
  const [modal_title, setModalTitle] = useState('新增');//弹窗标题
  const [form] = Form.useForm();
  const [btn_loading, setBtnLoading] = useState(false);//按钮加载

  const [statusLoading, setStatusLoading] = useState(false)//状态loading

  const [airfield_list, setAirfieldList] = useState([]);//机场数据字典


  const dockNameTypeRef = useRef([]);//机场名称列表
  const ws = useRef(null);//ws 对象
  const hasAirList = useRef(false)//机场是否在线

  //表格头搜索框
  const SearchProps = (dataIndex, text) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8, }} onKeyDown={(e) => e.stopPropagation()} >
        <Input
          ref={searchInput}
          placeholder={`搜索 ${text}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(confirm)} //回车搜索
          style={{ marginBottom: 8, display: 'block', }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, }}
          >
            搜索
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90, }}
          >
            重置
          </Button>

        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),//图标
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);//自动获得焦点
      }
    },
  });

  //表格操作列表
  const dropDownOption = (data) => {
    const typeArr = [//常规
      {
        key: 1,
        permissions: 519,
        label: (
          <div
            onClick={() => {
              let restartDockArr = JSON.parse(localStorage.getItem('dock_restartDockArr')) || []
              if (restartDockArr?.find(e => e.dockId === data.dock_id)?.time && (dayjs().valueOf() - restartDockArr?.find(e => e.dockId === data.dock_id)?.time) < (120 * 1000)) {
                message.warning('当前机场重启小于两分钟，请稍等片刻')
              } else {
                getDockElectricity(data);
              }
            }}
          >
            <CaretRightOutlined className='marR10' /> 临时执行
          </div>
        ),
      },
      {
        key: 2,
        permissions: 516,
        label: (
          <div onClick={() => { exportData(2, data.id) }}>
            <NodeIndexOutlined className='marR10' /> 导出航点
          </div>
        ),
      },
      {
        key: 3,
        permissions: 507,
        label: (
          <div
            onClick={() => {
              setChooseId(data.id);
              setDrawerShow(true);
              setModalTitle('编辑');
              form.setFieldsValue({
                fly_name: data.fly_name,
                dock_id: data.dock_id || null,
                fly_len: Number(data.fly_len),
                description: data.description
              }); //表单赋值
            }}
          >
            <EditOutlined className='marR10' /> 修改
          </div>
        ),
      },
      {
        key: 4,
        permissions: 510,
        label: (
          <div onClick={() => { DelRoutesFun(data.id) }}>
            <DeleteOutlined className='marR10' /> 删除
          </div>
        ),
      },
    ]
    // 下拉列表只能使用 items
    let arr = []
    typeArr.forEach((item) => {
      if (AirportPermissionsArr.indexOf(item.permissions) > -1 || item.permissions === '') {
        arr.push(item)
      }
      if (arr.length > 1 && arr[arr.length - 1].key === 4) {
        arr.splice(-1, 0, { type: 'divider' })
      }
    })
    return { items: arr }
  }

  //输入框搜索
  const handleSearch = (confirm) => {
    confirm()
  };

  //重置
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };

  //获取表格数据
  const getTableData = async (obj) => {
    setLoading(true);
    let params = {
      access_token: token,
      fly_type: obj.type,
      fly_name: obj.fly_name,
      dock_ids: obj.dock_id,
      description: obj.description,
      page: obj.page,
      perpage: obj.perpage,
    }
    let res = await getFlyRouteApi(params);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    let arr = res.data.items.length > 0 ? res.data.items.map((item) => {
      return {
        ...item, dock_id: Number(item.dock_id)
      }
    }) : [];
    setTableData(arr);
    setTotal(res.data.total);

    let dictionary = res.data?.dictionary?.dock_list.map((item) => {
      return {
        label: item.dockName,
        value: Number(item.id),
      }
    });

    let dock = res.data?.dictionary?.dock_list.map((item) => {
      return {
        text: item.dockName,
        value: Number(item.id),
      }
    });

    dockNameTypeRef.current = dock;
    setAirfieldList(dictionary)
    setLoading(false);
  }

  //跳转至管线编辑
  const ToMap = async (record) => {
    // window.open(basicPath + '/new_pipeline_inspection_edit_map?' + id + '&' + search.type + '&' + dock_id);
    window.open(`${basicPath}/new_pipeline_inspection_edit_map?${record.id}&${search.type}&${record.dock_id}&${record.take_off_lon_wgs84 || 0}&${record.take_off_lat_wgs84 || 0}`);
  }

  //新增|修改管线
  const onFinish = async (values) => {
    setBtnLoading(true);
    let obj = {
      access_token: token,
      fly_type: search.type,
      ...values,
    }
    if (choose_id) {
      obj.fr_id = choose_id;
    }
    let res = await setRoutesApi(obj);
    setBtnLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success(choose_id ? '编辑成功' : '新增成功');
    CloseDrawer();
    getTableData(search);

  };

  //临时执行
  const TemporaryFun = async (id) => {
    let obj = {
      access_token: token,
      fr_id: id,
    }
    let res
    if (localStorage.getItem('dock_companyType') === '2') {
      messageApi.open({
        type: 'loading',
        content: '正在准备临时执行...',
        duration: 0,
      });
      res = await temporaryExecutionApi(obj)
    } else {
      message.warning('暂未获取到当前角色所在公司')
      return
    }
    messageApi.destroy();
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success('执行成功');
    getTableData(search);
  }

  //删除
  const DelRoutesFun = async (id) => {
    let res = await delRoutesApi({
      access_token: token,
      fr_ids: id
    })
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    if (total > 10 && total % 2 === 1 && search.page > 1) {
      let num = search
      num.page = num.page - 1
      setSearch({ ...num })
      setCur(num - 1)
    }
    message.success('删除成功');
    getTableData(search);
  }

  //关闭弹窗
  const CloseDrawer = () => {
    setDrawerShow(false)
    form.resetFields();
    setChooseId('');
  }

  //导出管线、航点、标识桩
  const exportData = async (type, id) => {
    let res = await derivedInfoApi({
      access_token: token,
      fr_id: id,
      type: type
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '导出失败，请稍后重试~');
      return;
    }
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = res.data
    document.body.appendChild(link);
    link.click();
    // 释放的 URL 对象以及移除 a 标签
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
    message.success('导出成功~')
  }

  const setStatus = async (record, type) => { //修改警戒线状态
    setStatusLoading(true)
    let obj = {
      access_token: token,
      fr_ids: record.id,
      FieldName: 'cordon',
      FieldValue: type ? 1 : 0
    }
    let res = await setStatusApi(obj)
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      setStatusLoading(false)
      return;
    }
    setStatusLoading(false)
  }

  const setTableColumns = () => {
    let perm = localStorage.getItem('dock_AirportPermissionsArr') ? [...JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'))] : [];
    //表格头
    const list = [
      {
        title: 'ID',
        isShow: true,
        dataIndex: 'id',
        // sorter: () => { },
      },
      {
        title: '航线名称',
        isShow: true,
        dataIndex: 'fly_name',
        render: (text, record) => {
          return (
            <div>{text}</div>
          )
        },
        ...SearchProps('title', '航线名称'),
      },
      {
        title: '机场',
        isShow: true,
        dataIndex: 'dock_id',
        render: (text, record) => {
          return (
            text
              ? <div>{record.dock_name}</div>
              : <div style={{ color: colorTextPlaceholder }}>-</div>
          )
        },
        filters: dockNameTypeRef.current,
        filterMultiple: false,
      },
      {
        title: '总里程(km)',
        isShow: true,
        dataIndex: 'fly_len',
        // sorter: () => { },
      },
      // {
      //   title: '最新执行时间',
      //   isShow: true,
      //   dataIndex: 'last_executed_time_s',
      //   render: (text, record) => {
      //     return text
      //       ? (
      //         <div>
      //           <span className='marR8'>{text.substring(0, 10)}</span>
      //           <span className='opa45'>{text.substring(11, 16)}</span>
      //         </div>
      //       )
      //       : <div style={{ color: colorTextPlaceholder }}>-</div>
      //   },
      //   // sorter: () => { },
      // },
      // {
      //   title: '编辑人',
      //   isShow: true,
      //   dataIndex: 'username',
      //   render: (text, record) => {
      //     return (
      //       text
      //         ? (<span className='opa45'>{text}</span>)
      //         : <div style={{ color: colorTextPlaceholder }}>-</div>
      //     )
      //   },
      //   // sorter: () => { },
      // },
      // {
      //   title: '编辑时间',
      //   isShow: true,
      //   dataIndex: 'update_time',
      //   render: (text, record) => {
      //     return text
      //       ? (
      //         <div>
      //           <span className='opa45 marR8'>{text.substring(0, 10)}</span>
      //           <span className='opa45'>{text.substring(11, 16)}</span>
      //         </div>
      //       )
      //       : <div style={{ color: colorTextPlaceholder }}>-</div>
      //   },
      //   // sorter: () => { },
      // },
      {
        title: '巡检覆盖对象',
        isShow: true,
        dataIndex: 'description',
        render: (text, record) => {
          return (
            text
              ? (<div>{text}</div>)
              : <div style={{ color: colorTextPlaceholder }}>-</div>
          )
        },
        ...SearchProps('', '巡检覆盖对象'),
      },
      {
        title: '地图',
        isShow: perm.indexOf(528) >= 0,
        dataIndex: '',
        align: 'center',
        width: 80,
        render: (text, record) => {
          return (
            <div onClick={() => { ToMap(record) }}>
              <GlobalOutlined className='pointer col_primary' style={{ width: '16px', height: '16px' }} />
            </div>
          )
        },
      },
      {
        title: '绘制警戒线',
        width: 110,
        isShow: perm.indexOf(513) >= 0,
        align: 'center',
        render: (text, record) => {
          return (
            <Switch
              loading={statusLoading}
              defaultChecked={record.cordon}
              size='small'
              onClick={(e) => {
                setStatus(record, e)
              }}
            />
          )
        },
      },
      {
        title: '操作',
        isShow: true,
        dataIndex: '',
        align: 'center',
        width: 120,
        render: (text, record) => {
          return (
            <Dropdown
              menu={dropDownOption(record)}
              placement="bottom"
            >
              <MenuOutlined className='pointer col_primary' />
            </Dropdown>
          )
        }
      },
    ];
    let arr = []
    list.forEach(res => {
      if (res.isShow) { arr.push(res) }
    })
    return arr
  }

  const getAirportLive = async (url, dockSn) => { //机场是否在线

    ws.current = new WebSocket(url);

    ws.current.onopen = (msg) => {//链接开启
      console.log("链接成功", msg);
    };

    ws.current.onmessage = e => {// 成功获取数据
      try {
        let data = JSON.parse(e.data)

        if (data.biz_code === 'dock_osd' && data.data.sn === dockSn) {//机场
          if (data.data.host && JSON.stringify(data.data.host) !== '{}') {
            hasAirList.current = true
            return true
          }
        }
      } catch (error) {
        // message.warning('当前机场状态错误，请确认机场是否正确链接')
      }
    }

    ws.current.onerror = (msg) => {//报错信息
      // console.log('链接出错', msg)
    }

    ws.current.onclose = (msg) => {//链接断开
      console.log('链接断开');
      if (ws.current) {
        ws.current.close()
        ws.current = null
      }
      // clearInterval(settime)
      return false
    };


    // 3秒一次检查当前ws传回来的数据是否还在
    // let settime = setInterval(() => {
    //   let airTimes = Math.abs(Math.floor(dayjs().valueOf() - airTime) / 1000)
    //   if (airTimes > 3) { return false } else { return true }
    // }, 2000);
  }

  //获取机场电量
  const getDockElectricity = async (data) => {
    setLoading(true)
    if (ws.current) {
      ws.current.close()
      ws.current = null
    }
    let params = {
      access_token: token,
      dock_id: data.dock_id
    }
    let res = await getDockElectricityApi(params);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      setLoading(false)
      return;
    }

    if (!res.data.ws_host || !res.data.dockSn) {
      message.warning('暂未获取到ws地址或机场编号');
      setLoading(false)
      return;
    }

    let isLive = await getAirportLive(res.data.ws_host, res.data.dockSn)

    setTimeout(() => {
      if (isLive || hasAirList.current) {//机场是否存在
        setLoading(false)
        confirm({
          title: '电量提醒',
          icon: <ExclamationCircleFilled />,
          content: '当前无人机电量为' + res.data.battery_percent + '%，是否起飞',
          onOk() {
            TemporaryFun(data.id);
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          },
          onCancel() {
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          }
        });
      } else {
        setLoading(false)
        confirm({
          title: '电量提醒',
          icon: <ExclamationCircleFilled />,
          content: `当前无人机电量为${res.data.battery_percent}%且3s内未获取到机场信息，是否起飞`,
          okText: '已确认机场开启，可以起飞',
          onOk() {
            TemporaryFun(data.id);
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          },
          onCancel() {
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          }
        });
      }
    }, 3000);

  }

  useEffect(() => {
    console.log('---', location.pathname);
    let obj = { ...search };
    // 根据url地址确定当前属于哪个类型的记录
    switch (location.pathname) {
      case '/new_pipeline_inspection'://管网
        obj.type = 10;
        break;
      case '/routine_list_powerGrid_new'://新_电网
        obj.type = 11;
        break;
      default:
        break;
    }


    setSearch({ ...obj });
    getTableData(obj);
    setTimeout(() => {
      setAirportPermissionsArr(localStorage.getItem('dock_AirportPermissionsArr') ? [...JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'))] : [])
    }, 1000);

    //eslint-disable-next-line
  }, [location.pathname])

  return (
    <>
      {contextHolder}
      <Card style={{ border: 0 }} className="mar24" bodyStyle={{ padding: '24px' }}>
        <div className="flex jcsb pdRL12 pdB16 align_center">
          <div className="fs16 fw500 col_main_text marR12">航线列表</div>
          {
            AirportPermissionsArr.indexOf(504) >= 0 ?
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  // if (AirportPermissionsArrName.indexOf(`RoutesInfo_Add_${search.type}`) > -1) {
                  setChooseId('')
                  setDrawerShow(true)
                  setModalTitle('新增')
                  form.setFieldsValue({
                    dock_id: airfield_list.length > 0 ? airfield_list[0].value : null,
                    fly_len: null
                  });
                  // } else {
                  //   message.warning('暂无权限！')
                  // }
                }}
              >
                新增
              </Button> : ''
          }
        </div>
        <Table
          columns={[...setTableColumns()]}
          dataSource={tableData}
          pagination={false}
          loading={loading}
          rowKey='id'
          onChange={(pagination, filters, sorter) => {
            let obj = { ...search };
            obj.page = 1;
            setCur(1);
            for (let i in filters) {
              let val = filters[i];
              console.log('val', val);
              if (val) {
                obj[i] = filters[i].join(',');
              } else {
                obj[i] = ''
              }
            }
            setSearch({ ...obj });
            getTableData({ ...obj })
          }}
        >
        </Table>

        <div className='pdT16'>
          <Pagination align='end' current={cur} pageSize={page} total={total} showTotal={total => `共 ${total} 条数据`}
            onChange={
              (current, pageSize) => { //选择当前页后执行
                setCur(current);
                setPage(pageSize);
                let obj = { ...search };
                obj.page = current;
                obj.perpage = pageSize;
                setSearch({ ...obj });
                getTableData(obj);
              }
            } />
        </div>

        {/* 新增|编辑 弹窗 */}
        <Drawer
          title={modal_title}
          open={modal_show}
          width={256}
          footer={null}
          maskClosable={false}
          onClose={CloseDrawer}
          extra={
            <Button
              type='primary'
              loading={btn_loading}
              onClick={() => { form.submit() }}
            >
              提交
            </Button>
          }
        >
          <Form form={form} name='form' layout="vertical" onFinish={onFinish} style={{ marginTop: '12px' }}>
            <Form.Item label="航线名称" name="fly_name" rules={[{ required: true, message: '请输入单元名称', }, { pattern: /^.{0,20}$/, message: '名称不能超过20字符', }]}>
              <Input placeholder="-" />
            </Form.Item>

            <Form.Item label="总里程(km)" name="fly_len" hidden={choose_id ? false : true}
              rules={[{ required: choose_id ? true : false, message: '请输入单元名称', }]}>
              <InputNumber className='wid100' placeholder="-" />
            </Form.Item>

            <Form.Item label="机场" name="dock_id" rules={[{ required: true, message: '请选择机场', }]}>
              <Select style={{
                width: '100%',
              }} options={airfield_list}
              />
            </Form.Item>

            <Form.Item label="巡检覆盖对象" name="description">
              <TextArea placeholder="-" />
            </Form.Item>
          </Form>
        </Drawer>
      </Card >
    </>
  )
}
export default NewPipelineInspection